import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

export type StatusInfoRole = 'status' | 'alert' | null; // null will remove status info
export type StatusInfoModifier = Modifier<
  | 'center'
  | 'green'
  | 'margin-bottom'
  | 'margin-bottom-large'
  | 'margin-left'
  | 'margin-left-large'
  | 'padding-top'
  | 'padding'
  | 'red'
  | 'red-application'
  | 'right'
  | 'align-left'
>;
export type StatusInfoDataFormStatus = 'sending' | 'fail' | 'success' | 'forwarding';

export type StatusInfo = {
  role?: StatusInfoRole;
  modifier?: StatusInfoModifier;
  dataFormStatus?: StatusInfoDataFormStatus;
};

/**
 * Component to Render small Error Info.
 */
export function StatusInfo({ modifier, role = 'status', children, dataFormStatus }: PropsWithChildren<StatusInfo>) {
  return (
    <div
      className={bem('status-info', modifier)}
      role={role === null ? undefined : role}
      data-form-status={dataFormStatus}
    >
      {children}
    </div>
  );
}
